import React from 'react';
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";



function footer() {
  return (
    <div className="footer">
      <MDBFooter color="green" className="font-small pt-4 mt-4">
      <MDBContainer fluid className="text-center text-md-left">
        <MDBRow>
          <MDBCol md="6">
            <h5 className="title">Tech utilisé : Typescript & React</h5>
          </MDBCol>
          <MDBCol md="6">
            <h5 className="title">2021-2022</h5>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: Mitton Benjamin 
        </MDBContainer>
      </div>
    </MDBFooter>
    </div>
  );
}

export default footer;
